import { render } from "./ApplicationViewA.vue?vue&type=template&id=50c3f722&scoped=true"
import script from "./ApplicationViewA.vue?vue&type=script&lang=js"
export * from "./ApplicationViewA.vue?vue&type=script&lang=js"

import "./ApplicationViewA.vue?vue&type=style&index=0&id=50c3f722&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c3f722"]])

export default __exports__